// Object.defineProperty(exports, '__esModule', {
//   value: true
// })

import PropTypes from "prop-types";

var _extends =
  Object.assign ||
  function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };

var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _pikaday = require("pikaday");
var _pikaday2 = _interopRequireDefault(_pikaday);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

const componentProps = ["value", "onChange", "initialOptions", "valueLink"];

const propTypes = {
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  initialOptions: PropTypes.object,

  valueLink: PropTypes.shape({
    value: PropTypes.instanceOf(Date),
    requestChange: PropTypes.func.isRequired,
  }),
};

class ReactPikaday extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.pikadayRef = _react2.default.createRef();
  }

  static defaultProps = {
    initialOptions: {},
  };

  getValueLink(props) {
    return (
      props.valueLink || {
        value: props.value,
        requestChange: props.onChange,
      }
    );
  }

  setDateIfChanged(newDate, prevDate) {
    var newTime = newDate ? newDate.getTime() : null;
    var prevTime = prevDate ? prevDate.getTime() : null;

    if (newTime !== prevTime) {
      if (newDate === null) {
        // Workaround for pikaday not clearing value when date set to falsey
        this.pikadayRef.current.value = "";
      }
      this._picker.setDate(newDate, true); // 2nd param = don't call onSelect
    }
  }

  setMinDateIfChanged(newMinDate, prevMinDate) {
    var newTime = newMinDate ? newMinDate.getTime() : null;
    var prevTime = prevMinDate ? prevMinDate.getTime() : null;

    if (newTime !== prevTime) {
      if (newMinDate === null) {
        // Workaround for pikaday not clearing value when date set to falsey
        this.pikadayRef.current.value = "";
      }
      this._picker.setMinDate(newMinDate, true); // 2nd param = don't call onSelect
    }
  }

  setMaxDateIfChanged(newMaxDate, prevMaxDate) {
    var newTime = newMaxDate ? newMaxDate.getTime() : null;
    var prevTime = prevMaxDate ? prevMaxDate.getTime() : null;

    if (newTime !== prevTime) {
      if (newMaxDate === null) {
        // Workaround for pikaday not clearing value when date set to falsey
        this.pikadayRef.current.value = "";
      }
      this._picker.setMaxDate(newMaxDate, true); // 2nd param = don't call onSelect
    }
  }

  // user props to pass down to the underlying DOM node
  getDomProps() {
    var restProps = {};

    for (var propKey in this.props) {
      if (this.props.hasOwnProperty(propKey) && !componentProps.includes(propKey)) {
        restProps[propKey] = this.props[propKey];
      }
    }

    return restProps;
  }

  componentDidMount() {
    var el = this.pikadayRef.current;

    this._picker = new _pikaday2.default(
      _extends(
        {
          field: el,
          onSelect: this.getValueLink(this.props).requestChange,
        },
        this.props.initialOptions
      )
    );

    this.setDateIfChanged(this.getValueLink(this.props).value);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var newDate = this.getValueLink(nextProps).value;
    var lastDate = this.getValueLink(this.props).value;

    this.setDateIfChanged(newDate, lastDate);
    this.setMinDateIfChanged(nextProps.initialOptions.minDate, this.props.initialOptions.minDate);
    this.setMaxDateIfChanged(nextProps.initialOptions.maxDate, this.props.initialOptions.maxDate);
  }

  render() {
    return _react2.default.createElement(
      "input",
      _extends({ type: "text", ref: this.pikadayRef, className: "input" }, this.getDomProps())
    );
  }
}

//ReactPikaday.propTypes = propTypes;

export default ReactPikaday;
